<h2 mat-dialog-title>{{ data.message }}</h2>

<mat-dialog-actions>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onSuccessResponse()">{{ data.confirmText || 'Yes' }}</button>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onNegativeResponse()">{{ data.cancelText || 'No' }}</button>
</mat-dialog-actions>